import { getConfiguration } from "./configuration";

export function getCurrencySymbol(currency) {
	if(!currency) {
		const conf = getConfiguration();
		currency = conf.cs.ct;
	}
	let symbol = currency;
	let htmlCode = null;
	if (currency.toUpperCase().trim() === 'EUR') {
		htmlCode = '&euro;';
	}
	else if (currency.toUpperCase().trim() === 'TND') {
		htmlCode = 'DT';
	}
	else if (currency.toUpperCase().trim() === 'NGN') {
		htmlCode = '&#8358;';
	}
	else if (currency.toUpperCase().trim() === 'USD') {
		htmlCode = '&#36;';
	}
	else if (currency.toUpperCase().trim() === 'BGR') {
		htmlCode = '&#1083;&#1074;';
	}
	else if (currency.toUpperCase().trim() === 'BGN') {
		htmlCode = '&#1083;&#1074;';
	}
	if (htmlCode != null) {
		let span = document.createElement('span');
		span.innerHTML = htmlCode;
		if (span.textContent.length > 0) {
			symbol = span.textContent;
		}
	}
	return symbol;
}
